import React, { Component } from 'react'
import { formatName } from '../../../helpers'

class VoteRow extends Component {
  render () {
    const { vote, player, team } = this.props

    return (
      <div className='vote-row'>
        <div className='vote-user'>
          <div className='vote-user-photo' style={{ background: `url(${player.avatar || '/imgs/default-avatar.png'}) center center / cover no-repeat` }} />
          <div className='user-info'>
            <div>{formatName(player.name)}</div>
            <div>{team && team.name}</div>
          </div>
        </div>
        <div className='cell-answer-text'>
          {vote.vote}
        </div>
      </div>
    )
  }
}

export default VoteRow



// WEBPACK FOOTER //
// ./src/components/common/popups/VoteRow.js